import logo from './logo.svg';
import './App.css';
import PageRoutes from './Routes/PageRoutes';

function App() {
  // const token = response.data.token; 
  const token = "sdasddsfsdklkfldfeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ijc1Yzg2YTA4LTRiYjYtNDIxMi1iYjJiLWU5ZjA1YWIxNzg3MSIsIm5iZiI6MTcwNzQ2NjA2OCwiZXhwIjoxNzA3NDY5NjY4LCJpYXQiOjE3MDc0NjYwNjgsImlzcyI6Imh0dHA6Ly9sb2NhbGhvc3Q6NjA2NDYiLCJhdWQiOiJodHRwOi8vbG9jYWxob3N0OjYwNjQ2In0.p8wwJqTyu99dEYVKON9kuzrPRcFCtOfYq3HgCdqWCXc"
sessionStorage.setItem('authToken', token);
  return (
    <PageRoutes />
  );
}

export default App;
